import { AxiosError, AxiosRequestConfig } from "axios";

type ItemsHttpResponse = {
  status?: number;
  data?: unknown;
} | null | undefined;

type GetMethod = (
  url: any,
  config?: AxiosRequestConfig,
) => Promise<ItemsHttpResponse>;

export const returnRequestItemsPath = (
  pharmacyId: string,
  requestId: string,
) => `/pharmacies/${pharmacyId}/returnrequests/${requestId}/items`;


export const normalizeReturnRequestItems = <T = any>(
  response: ItemsHttpResponse,
): T[] => {
  if (!response || response.status === 204) {
    return [];
  }

  const { data } = response;
  if (data == null || data === "") {
    return [];
  }

  return Array.isArray(data) ? (data as T[]) : [];
};

export const fetchReturnRequestItems = async <T = any>(
  getMethod: GetMethod,
  pharmacyId: string,
  requestId: string,
  config?: AxiosRequestConfig,
): Promise<T[]> => {
  try {
    const response = await getMethod(
      returnRequestItemsPath(pharmacyId, requestId),
      config,
    );
    return normalizeReturnRequestItems<T>(response);
  } catch (error) {
    const err = error as AxiosError;
    if (err.response?.status === 204) {
      return [];
    }
    throw error;
  }
};
